import { render, staticRenderFns } from "./TableButton.vue?vue&type=template&id=38efe135&scoped=true&"
import script from "./TableButton.vue?vue&type=script&lang=js&"
export * from "./TableButton.vue?vue&type=script&lang=js&"
import style0 from "./TableButton.vue?vue&type=style&index=0&id=38efe135&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38efe135",
  null
  
)

export default component.exports